import React from 'react';
// import { Link } from 'react-router-dom';
import Hero from './hero';
import Statistics from './statistics';
import Services from './services';
import Quotes from './quotes';
import Projects from './projects';
// import TechInnovation from './tech-innovation';
import NewsFeed from './newsfeed';
import Contacts from './contacts';

const HomePage = () => {
  return (
    <div>
      <Hero />
      <Statistics />
      <Services />
      <Quotes />
      <Projects />
      {/* <TechInnovation /> */}
      <NewsFeed />
      <Contacts />
    </div>
  );
};

export default HomePage;
